import { render, staticRenderFns } from "./desc-node.vue?vue&type=template&id=2bbdb668"
import script from "./desc-node.vue?vue&type=script&lang=js"
export * from "./desc-node.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports